var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-resumed-link-component"},[_c('a',{staticClass:"cell-resumed-link",attrs:{"href":_vm.href,"target":"_blank","alt":_vm.text,"title":_vm.text}},[_vm._v(" "+_vm._s(_vm.truncatedText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }